import { render } from "./OSClaims.vue?vue&type=template&id=a7cb0f88&scoped=true"
import script from "./OSClaims.vue?vue&type=script&lang=js"
export * from "./OSClaims.vue?vue&type=script&lang=js"

import "./OSClaims.vue?vue&type=style&index=0&id=a7cb0f88&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7cb0f88"]])

export default __exports__